module.exports = __webpack_public_path__ + "static/media/South-Asia-Logo.a0df5e1d.png";